const textVideoComponent = () => {
  const playBtn = document.querySelector(".js-vt-svg");
  const image = document.querySelector(".js-vt-image");
  const videoIframe = document.querySelector(".js-vt-video-iframe");
  const videoHTML = document.querySelector(".js-vt-video-html");
  if (!playBtn) return;
  playBtn.addEventListener("click", (e) => {
    e.preventDefault();
    playBtn.classList.add("hide");
    image.classList.add("hide");
    if (videoIframe) {
      videoIframe.classList.add("show");
      videoIframe.src += "?autoplay=1&mute=1";
    }
    if (videoHTML) {
      videoHTML.classList.add("show");
      videoHTML.play();
    }
  });
};

export default textVideoComponent;
